'use strict';

module.exports = {
	CAMP_NO_LICENCED_GROUPS: 'campNoLicencedGroups',
	CAMP_PRODUCT_HIDDEN: 'campProductHidden'
};
